import React, { useEffect, useState, useContext } from 'react'
import { Col, Container, Jumbotron, Row } from "react-bootstrap"
import { RiArrowLeftSLine, RiArrowRightSLine } from "react-icons/ri"
import { withTranslation } from 'react-i18next';
import ReactPaginate from "react-paginate"
import Get from '../../api/Get'
import { DOCTOR_BY_EMAIL, DOCTOR_MY_APPOINTMENT } from '../../api/Routes'
import { authContext } from "../../context/AuthContext";
import LoadingList from "../../loader/LoadingList"
import { isCitasProximas } from "../../utils/isCitasProximas"
import CardCitasCliente from '../../components/CardCitasCliente'
import CancelCitaModal from './modals/CancelCitaModal'
import { toast } from 'react-toastify';
import ComponentModalErrorSever from '../../components/ComponentModalErrorSever';

const HisorialCitas = ({ t }) => {
    const [proximasCitas, setProximasCitas] = useState([])
    const [previasCitas, setPreviasCitas] = useState([])
    const [loading, setLoading]= useState(false)
    const [doctor, setDoctor] = useState()
    const [idDoctor, setidDoctor] = useState()
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPagePC, setCurrentPagePC] = useState(1)
    const [pageCount, setPageCount] = useState(0)
    const [currentPagePageCount, setCurrentPagePageCount] = useState(0)
    const [showCancelModal, setShowCancelModal] = useState(false)
    const [citaToCancel, setCitaToCancel] = useState()
    const [loadData, setLoadData] = useState(true)

    const postsPerPage = 10;
    const indexOfLastPost = currentPage * postsPerPage;
    const indexOfFirstPost = indexOfLastPost - postsPerPage;
    const PCLastPost = currentPagePC * postsPerPage
    const PCFirstPost= PCLastPost - postsPerPage

    //Token de autentificación para los servicios
    const {auth} = useContext(authContext)

    const [errorServer, setErrorServer] = useState(null)
    const [showModalServer, setShowModalServer] = useState(false)
    const handleCloseModalServer = () => {
        setShowModalServer(false)
    }  

    useEffect(() => {
        let mounted = true;
        const url = encodeURI(`${DOCTOR_BY_EMAIL}/${auth.data.username}`)
        setLoading(true)

        Get({url: url, access_token: auth.data.access_token}).then((resp) => {
            if(mounted) {
                setDoctor(resp.data.data)
                setidDoctor(resp.data.data.id)
            }            
            setLoading(false)
        }).catch((error) => {
            setShowModalServer(true)
            if(error.response){
                setErrorServer(error.response)
            }
            setLoading(false)

        })
        return () => mounted = false;
    }, [])

    useEffect(() => {
        if(idDoctor) {
            let mounted = true
            const url = encodeURI(`${DOCTOR_MY_APPOINTMENT}/${idDoctor}`)
            setLoading(true)
            Get({url: url, access_token: auth.data.access_token})
            .then((resp) => {
                if(mounted){
                    let data = resp.data.data.response;
                    let proximasCitas = data.filter(item=>isCitasProximas(item.scheduleDTO.dateTimeInit)).reverse()
                    let citasPrevias = data.filter(item=>!isCitasProximas(item.scheduleDTO.dateTimeInit))
                    setProximasCitas(proximasCitas)
                    setPreviasCitas(citasPrevias)

                    if(data.length > 0){
                        let pC = Math.ceil(citasPrevias.length / postsPerPage)
                        setPageCount(pC)

                        let pageCounter = Math.ceil(proximasCitas.length / postsPerPage)
                        setCurrentPagePageCount(pageCounter)
                    }
                }
                setLoading(false)
            }).catch((error) => {
                setShowModalServer(true)
                if(error.response){
                    setErrorServer(error.response)
                }
                setLoading(false)
            })
        }
    }, [idDoctor, loadData])

    const handlePageClick = (data) => setCurrentPage(data.selected + 1)
    const handlePageProximaCitaClick = (data) => setCurrentPagePC(data.selected + 1)
    const handleShowModalCalcel = (item) => {
        setCitaToCancel(item)
        setShowCancelModal(true)
    }
    const handleCloseModalCalcel = () => setShowCancelModal(false)
    

    return (<>
        {loading && <LoadingList />}

        <CancelCitaModal show={ showCancelModal } 
            handleHideModal={ handleCloseModalCalcel } 
            item={ citaToCancel } 
            setLoading={ setLoading }
            setLoadData={ setLoadData }
            setShowModalServer={setShowModalServer}
            setErrorServer={setErrorServer}
        />

        <div className='body'>
            <Row className="align-items-center">
                <Col xs="12" md="8">
                    <h2 className="mb-0 title-top-2">{ t('mis_citas') }</h2>
                    {doctor && <label className="font-weight-bold text-secondary">{`${doctor?.name} ${doctor?.lastName}`}</label>}
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="12"><h2 className="color-646D82">{ t('proximas') }</h2></Col>
                <Col xs="12" md="12">
                    {
                        (proximasCitas.length === 0) ? <Row className="mt-5">
                            <Col>
                                <Jumbotron>
                                    <Container>
                                        <p className="text-center">{ t('no_hay_citas') }</p>
                                    </Container>
                                </Jumbotron>
                            </Col>
                        </Row> : <Row>
                            {
                                proximasCitas.slice(PCFirstPost, PCLastPost).map((item, i)=>(
                                    <Col xs="12" md="4" key={i}>
                                        <CardCitasCliente item={item} showModal={handleShowModalCalcel} auth={auth} />
                                    </Col>
                                ))
                            }
                        </Row>
                    }
                    {
                        proximasCitas.length > 0 && <Row className="mt-5">
                            <Col>
                                <ReactPaginate
                                    previousLabel={ <RiArrowLeftSLine /> }
                                    nextLabel={ <RiArrowRightSLine /> }
                                    breakLabel={ '...' }
                                    breakClassName={ 'break-me' }
                                    pageCount={ currentPagePageCount }
                                    marginPagesDisplayed={ 2 }
                                    pageRangeDisplayed={ 3 }
                                    onPageChange={ handlePageProximaCitaClick }
                                    containerClassName={ 'pagination' }
                                    subContainerClassName={ 'pages pagination' }
                                    activeClassName={ 'active' }
                                />
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
            <Row>
                <Col xs="12" md="12"><h2 className="color-646D82">{ t('anteriores') }</h2></Col>
                <Col xs="12" md="12">
                    {
                        (previasCitas.length === 0) ? <Row className="mt-5">
                            <Col>
                                <Jumbotron>
                                    <Container>
                                        <p className="text-center">{ t('no_hay_citas') }</p>
                                    </Container>
                                </Jumbotron>
                            </Col>
                        </Row> : <Row>
                            {
                                previasCitas.slice(indexOfFirstPost, indexOfLastPost).map((item, i)=>(
                                    <Col xs="12" md="4" key={i}>
                                        <CardCitasCliente item={item} 
                                            showModal={handleShowModalCalcel} 
                                            showDelete={ false } 
                                            showEdit={ false } 
                                            auth={auth}
                                        />
                                    </Col>
                                ))
                            }
                        </Row>
                    }
                    
                    {
                        previasCitas.length > 0 && <Row className="mt-5">
                            <Col>
                                <ReactPaginate
                                    previousLabel={<RiArrowLeftSLine />}
                                    nextLabel={<RiArrowRightSLine />}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={3}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                />
                            </Col>
                        </Row>
                    }
                </Col>
            </Row>
        </div>
        <ComponentModalErrorSever
            show={showModalServer}
            handleClose={handleCloseModalServer}
            error={errorServer}
        />
    </>)
}

export default withTranslation()(HisorialCitas)